import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const init = (isRM) => {
  const pricingHero = document.querySelector('.pricing-hero');
  if (!pricingHero) return;

  const screenW = innerWidth;
  const bigText = pricingHero.querySelector('.pricing-hero__background-text');
  const bigTextW = bigText.offsetWidth;
  const multiplier = Math.ceil(screenW / bigTextW) + 2;
  const bigTextValue = bigText.textContent;
  let str = `${bigTextValue}`;

  for (let i = 0; i < multiplier; i++) {
    str += bigTextValue;
  }
  bigText.innerHTML = str;

  if (isRM) return;

  const pricing = gsap.to('.pricing-hero__background-text', {
    repeat: -1,
    xPercent: -100 / (multiplier + 1),
    ease: 'none',
    duration: 8
  });

  ScrollTrigger.create({
    trigger: pricingHero,
    start: 'top bottom',
    end: 'bottom top',
    animation: pricing,
    toggleActions: 'play pause resume pause'
  });

  // follows
  const housesYTo = gsap.quickTo('.pricing-hero', '--pricing-y', {
    duration: 2,
    ease: 'sine'
  });

  const housesXTo = gsap.quickTo('.pricing-hero', '--pricing-x', {
    duration: 1.4,
    ease: 'sine'
  });

  const housesRotateTo = gsap.quickTo('.pricing-hero', '--pricing-r', {
    duration: 2,
    ease: 'sine'
  });

  pricingHero.addEventListener('mousemove', (e) => {
    if (e.clientY + window.scrollY <= innerHeight) {
      housesYTo(gsap.utils.mapRange(0, innerHeight, -16, 16, e.clientY));
      housesXTo(gsap.utils.mapRange(0, innerHeight, -8, 8, e.clientX));
      housesRotateTo(gsap.utils.mapRange(0, innerHeight, 30, -30, e.clientY));
    }
  });
};

export { init };
